export default () => {

  const slickItems = document.getElementsByClassName("section--tips")[0];
  /**
   * Intersection Observer setup
   */
  const observerOptions = {
    root: null,
    rootMargin: "0px",
    threshold: 0.33,
  };
  const observerCallback = (entries, observer) => {

    // entries.forEach((entry) => {
    //   if (entry.intersectionRatio > 0.33) {
    //     entry.target.classList.add("animation--fall");
    //     observer.unobserve(entry.target);
    //   }
    // });
    
    for(let i=0; i<entries.length; i++) {
      if (entries[i].intersectionRatio > 0.33) {
        entries[i].target.classList.add("animation--fall");
        observer.unobserve(entries[i].target);
      } 
    }

  };
  const intersectionObserver = new IntersectionObserver(observerCallback, observerOptions);

  /**
   * Hide elements on start
   */

  intersectionObserver.observe(slickItems);

};